"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const formik_1 = require("formik");
const react_1 = __importStar(require("react"));
const react_native_paper_dates_1 = require("react-native-paper-dates");
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const constants_1 = require("../../../constants/constants");
const eventConstants_1 = require("../../../constants/eventConstants");
const typesConstants_1 = require("../../../constants/typesConstants");
const actionsSlice_1 = require("../../../features/actions/actionsSlice");
const useAppDispatch_1 = __importDefault(require("../../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../../hooks/useAppSelector"));
const useWebDesktopDesign_1 = __importDefault(require("../../../hooks/useWebDesktopDesign"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const themes_1 = __importDefault(require("../../../styles/themes"));
const utils_1 = require("../../../utils/utils");
const boxTitle_1 = __importDefault(require("../../boxTitle/boxTitle"));
const button_1 = __importDefault(require("../../button/button"));
const FieldErrorMessageComponent_1 = __importDefault(require("../../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const radioInput_1 = __importDefault(require("../../radioInput/radioInput"));
const communicationBoxUtils_1 = __importStar(require("../communicationBoxUtils"));
const callFeedBackConstants_1 = require("./callFeedBackConstants");
const pressable_1 = __importDefault(require("../../pressable/pressable"));
const callFeedbackMultiSelect_1 = __importDefault(require("../../callFeedbackMultiSelect/callFeedbackMultiSelect"));
const callFeedbackMultiSelectConstants_1 = __importStar(require("../../callFeedbackMultiSelect/callFeedbackMultiSelectConstants"));
const CALL_WITH_ISSUES = -1;
const PROMISED_TO_PAY = 2;
const PROMISED_TO_TAKE_LOAN = 9;
const choicesCustomerAnswer = (isVoipCall, isLoanSchedule) => {
    const choices = [
        { value: 0, label: 'Yes' },
        { value: 1, label: 'No' },
        { value: isLoanSchedule ? PROMISED_TO_PAY : PROMISED_TO_TAKE_LOAN, label: 'Promised' },
    ];
    if (isVoipCall) {
        choices.push({ value: CALL_WITH_ISSUES, label: 'Call with issues' });
    }
    return choices;
};
const getMappedCategories = (keys, mapping) => {
    const categories = new Set();
    keys.forEach((key) => {
        const value = mapping.get(key);
        const category = value ? value.category : undefined;
        if (category !== undefined) {
            categories.add(category);
        }
    });
    return categories;
};
const defaultProps = {
    duration: null,
    disableSaveButton: false,
};
const CallFeedback = ({ setBaseContent, duration = null, selectedContact, callType, provider, sipData, disableSaveButton, }) => {
    const today = new Date();
    const dispatch = useAppDispatch_1.default();
    const isDesktop = useWebDesktopDesign_1.default();
    const [valueCustomerAnswer, setValueCustomerAnswer] = react_1.useState(null);
    const [valueCallIssue, setValueCallIssue] = react_1.useState(null);
    const [valuePaymentDelayReasons, setValuePaymentDelayReasons] = react_1.useState([]);
    const [escalationReasons, setEscalationReasons] = react_1.useState([]);
    const [durationTime, setDurationTime] = react_1.useState(duration || callFeedBackConstants_1.TIMER_START_VALUE);
    const [counting, setCounting] = react_1.useState(false);
    const [validManualDuration, setValidManualDuration] = react_1.useState(true);
    const [ptpDate, setPtpDate] = react_1.useState(today);
    const [dateModalVisible, setDateModalVisible] = react_1.useState(false);
    const isVoipCall = !!duration;
    const formatedPtpDate = ptpDate && utils_1.formatDateISOString(ptpDate);
    // broken to two statements to circumvent 'no-nested-ternary' eslint error.
    const resumeOrStartCounterText = durationTime === callFeedBackConstants_1.TIMER_START_VALUE || !durationTime ? 'Start Timer' : 'Resume Timer';
    const counterText = counting ? 'Stop timer' : resumeOrStartCounterText;
    // this component is already rendered when the call ends
    // we need to force the setDurationTime if the duration changes.
    // This is not used for regularCall (duration !== null) since 'duration' prop will always be null.
    // this would mean, always setting 'durationTIme' to null. which is NOT what we want.
    if (duration !== durationTime && duration !== null) {
        setDurationTime(duration);
    }
    const { errors, schedule } = useAppSelector_1.default((state) => ({
        errors: state.actions.logCall.errors,
        schedule: state.schedule.schedule,
    }));
    const initialValues = {
        valueCustomerAnswer: null,
        durationTime: duration,
        feedback: '',
    };
    react_1.useEffect(() => {
        let interval = null;
        if (counting) {
            const newDate = new Date();
            const currentDurationInSeconds = communicationBoxUtils_1.convertTimeToSeconds(durationTime || '');
            // NOTE: setInterval here is simply to give the user a visual increment of the time,
            // and has nothing to do with actual setting of the time.
            // LOGIC: Get a new Date object each second, subtract from initial date set outside the setInterval, we get diff in milliseconds,
            // divide by 1000 to get the total seconds. this leaves us with the current running duration. we get the value of any previous duration
            // in seconds (currentDurationInSeconds) and add to the current running duration then formatDuration formats it appropriately.
            interval = setInterval(() => setDurationTime(communicationBoxUtils_1.default(Math.floor((new Date().getTime() - newDate.getTime()) / 1000) + currentDurationInSeconds)), 1000);
        }
        else if (interval) {
            clearInterval(interval);
        }
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [counting]);
    const onDateModalDismiss = () => {
        setDateModalVisible(false);
    };
    const onDateModalConfirm = (params) => {
        onDateModalDismiss();
        setPtpDate(params.date);
    };
    const formatPhoneNumber = (phone_number) => {
        if (phone_number.startsWith('0')) {
            // replace first 0 with +234, since the backend suports only international phone number formats
            return phone_number.replace('0', '+234');
        }
        return phone_number;
    };
    const scheduleId = schedule.id;
    const isLoanSchedule = schedule.external_id_type === typesConstants_1.EXTERNAL_ID_TYPE_LOAN;
    const promiseValue = isLoanSchedule ? PROMISED_TO_PAY : PROMISED_TO_TAKE_LOAN;
    const onFeedbackSubmit = (payload) => {
        const isCallWithIssues = valueCustomerAnswer === CALL_WITH_ISSUES;
        const isPromised = valueCustomerAnswer === promiseValue;
        const fullPayload = {
            scheduleId,
            recipient_name: `${selectedContact.first_name} ${selectedContact.last_name}`,
            recipient_phone_number: formatPhoneNumber(selectedContact.phone_number),
            call_type: callType,
            call_status: isVoipCall && isCallWithIssues ? valueCallIssue : valueCustomerAnswer,
            // if duration input is not formatted properly this should be null, the backend will handle it
            duration: durationTime && durationTime.split(':').length === 3 ? durationTime : null,
            notes: payload.feedback,
            ...(isVoipCall && isCallWithIssues && { sip_data: sipData }),
            ...(isPromised && {
                [isLoanSchedule ? 'ptp_date' : 'pttl_date']: formatedPtpDate,
            }),
            ...((provider || provider === 0) && { provider: provider.backend_value }),
            ...(valuePaymentDelayReasons.length > 0 && {
                payment_delay_reasons: valuePaymentDelayReasons,
                payment_delay_reason_categories: [
                    ...getMappedCategories(valuePaymentDelayReasons, callFeedbackMultiSelectConstants_1.DELAY_REASON_MAPPING),
                ],
            }),
            ...(escalationReasons.length > 0 && {
                escalation_reasons: escalationReasons,
                escalation_reason_categories: [...getMappedCategories(escalationReasons, callFeedbackMultiSelectConstants_1.ESCALATION_REASON_MAPPING)],
            }),
        };
        dispatch(actionsSlice_1.logCall(fullPayload)).then((result) => {
            if (result.meta.requestStatus === constants_1.FULFILLED_RESPONSE_CONSTANT) {
                setBaseContent();
            }
        });
    };
    // set the call_status to promised to display error if officer selected this option but there was an error
    // during processing
    if (errors && errors.ptp_date && !valueCustomerAnswer) {
        setValueCustomerAnswer(promiseValue);
    }
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: (values) => onFeedbackSubmit(values) }, ({ handleChange, handleSubmit, values }) => (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('recipient_phone_number', errors) }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(boxTitle_1.default, { title: "Did the customer answer?" })),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(radioInput_1.default, { choices: choicesCustomerAnswer(isVoipCall, isLoanSchedule), value: valueCustomerAnswer, setValue: setValueCustomerAnswer, isHorizontal: isDesktop }),
            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('call_status', errors) })),
        valueCustomerAnswer === promiseValue && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_paper_dates_1.DatePickerModal, { locale: "en", mode: "single", visible: dateModalVisible, onDismiss: onDateModalDismiss, date: ptpDate, onConfirm: onDateModalConfirm, label: `Select the ${isLoanSchedule ? 'promise to pay' : 'promise to take a loan'} date`, validRange: {
                    startDate: today,
                } }),
            react_1.default.createElement(pressable_1.default, { onPress: () => setDateModalVisible(true), eventName: eventConstants_1.PROMISE_TO_PAY_DATE_BUTTON },
                react_1.default.createElement(react_native_paper_1.TextInput, { label: `Date to ${isLoanSchedule ? 'pay' : 'take a loan'}`, left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput, value: formatedPtpDate }),
                react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('ptp_date', errors) })))),
        !isVoipCall ? (react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.flexOne,
                styles_1.default.flexDirectionColumn,
                styles_1.default.marginTwenty,
                styles_1.default.alignCenterCenter,
            ] },
            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('duration', errors) }),
            !validManualDuration && react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: callFeedBackConstants_1.INVALID_DURATION_INPUT_ERROR_TEXT }),
            react_1.default.createElement(react_native_paper_1.TextInput, { label: "Duration of the call", placeholder: "HH:MM:SS", onChangeText: (text) => {
                    // Prevent officer from manually overriding while counter is actively running.
                    if (counting)
                        return;
                    setDurationTime(text);
                    setValidManualDuration(text === '' || callFeedBackConstants_1.DURATION_TIME_FORMAT_REGEX.test(text));
                }, value: durationTime || '', style: [styles_1.default.textInput, { width: 180, minWidth: 180 }], theme: themes_1.default.textInput, left: true }),
            react_1.default.createElement(button_1.default, { text: counterText, icon: free_solid_svg_icons_1.faClock, onPress: () => setCounting(!counting), fill: true, eventName: eventConstants_1.TOGGLE_TIMER_BUTTON }))) : null,
        isVoipCall && valueCustomerAnswer === CALL_WITH_ISSUES ? (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                react_1.default.createElement(boxTitle_1.default, { title: "Did the call have issues?" })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                react_1.default.createElement(radioInput_1.default, { choices: callFeedBackConstants_1.CALL_WITH_ISSUES_CHOICES, value: valueCallIssue, setValue: setValueCallIssue, isHorizontal: isDesktop })))) : null,
        react_1.default.createElement(react_native_paper_1.TextInput, { label: "Your feedback here (optional)", placeholder: "Your feedback here (optional)", onChangeText: handleChange('feedback'), left: true, style: [styles_1.default.textInput, styles_1.default.marginTen], theme: themes_1.default.textInput, value: values.feedback }),
        react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('notes', errors) }),
        isLoanSchedule && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
            react_1.default.createElement(callFeedbackMultiSelect_1.default, { eventName: eventConstants_1.TAP_PAYMENT_DELAY_REASON_BUTTON, title: callFeedbackMultiSelectConstants_1.PAYMENT_DELAY_REASONS_TITLE, choices: callFeedbackMultiSelectConstants_1.default, mapping: callFeedbackMultiSelectConstants_1.DELAY_REASON_MAPPING, selectedValues: valuePaymentDelayReasons, setSelectedValues: setValuePaymentDelayReasons }),
            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('payment_delay_reasons', errors) }),
            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('payment_delay_reason_categories', errors) }),
            react_1.default.createElement(callFeedbackMultiSelect_1.default, { eventName: eventConstants_1.TAP_ESCALATION_BUTTON, title: callFeedbackMultiSelectConstants_1.REPORT_ISSUE_REASONS_TITLE, choices: callFeedbackMultiSelectConstants_1.ESCALATION_REASON_CHOICES, mapping: callFeedbackMultiSelectConstants_1.ESCALATION_REASON_MAPPING, selectedValues: escalationReasons, setSelectedValues: setEscalationReasons }),
            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('escalation_reasons', errors) }),
            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: utils_1.getError('escalation_reason_categories', errors) }))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterCenter, styles_1.default.flexOne] },
            react_1.default.createElement(button_1.default, { text: constants_1.SAVE_AND_CLOSE, icon: free_solid_svg_icons_1.faCheckCircle, onPress: handleSubmit, fill: true, eventName: eventConstants_1.SEND_FEEDBACK_BUTTON, disabled: valueCustomerAnswer === null || disableSaveButton }))))));
};
CallFeedback.defaultProps = defaultProps;
exports.default = CallFeedback;
